import { Moment } from './moment';

export type OverdueStatusClass =
  | 'text-success'
  | 'text-warning'
  | 'text-danger'
  | '';

export function getOverdueStatusClassByDays(
  daysOverdue: number,
  daysConsiderDelay: number
): OverdueStatusClass {
  if (daysOverdue <= 0) return 'text-success';
  if (daysOverdue <= daysConsiderDelay) return 'text-warning';
  return 'text-danger';
}

export function getOverdueStatusClassByDate(
  date: Date | string | null | undefined,
  daysConsiderDelay: number
): OverdueStatusClass {
  if (!date) return '';
  const ref = Moment(date).startOf('day');
  const today = Moment().startOf('day');
  const days = today.diff(ref, 'days');
  return getOverdueStatusClassByDays(days, daysConsiderDelay);
}
